/**
 * @generated SignedSource<<e5e20077614baa38ab4cd59fc26e707f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BreaksBetweenMeetingsBehaviourEnum = "END_EARLY" | "START_LATE";
export type DayOfWeekEnum = "FRIDAY" | "MONDAY" | "SATURDAY" | "SUNDAY" | "THURSDAY" | "TUESDAY" | "WEDNESDAY";
export type MeetingCostUnitEnum = "CURRENCY" | "HOURS";
import { FragmentRefs } from "relay-runtime";
export type EventFormModal_viewer$data = {
  readonly account: {
    readonly billingAccount: {
      readonly hasAccessToMeetingCost: boolean;
      readonly hasAccessToMeetingGuidelines: boolean;
      readonly hasAccessToMeetingRecorderFeature: boolean;
    };
    readonly extensionSettings: {
      readonly attendeeWeeklyMeetingHoursLimit: number;
      readonly attendeeWeeklyMeetingHoursWarningEnabled: boolean;
      readonly breaksBetweenMeetingsBehaviour: string;
      readonly breaksBetweenMeetingsEnabled: boolean;
      readonly finiteRecurringMeetingsEnabled: boolean;
      readonly maxRecommendedAttendees: number;
      readonly meetingAttendeesEnabled: boolean;
      readonly meetingCostAvgSalary: number;
      readonly meetingCostEnabled: boolean;
      readonly meetingCostEnforceWorkspaceSettings: boolean;
      readonly meetingCostUnit: MeetingCostUnitEnum;
      readonly noMeetingDay: DayOfWeekEnum;
      readonly noMeetingDaysEnabled: boolean;
      readonly promptWhenSavingEnabled: boolean;
      readonly promptWhenSavingGuidelinesUrl: string;
      readonly shortNoticeEnabled: boolean;
      readonly shortNoticeNumHours: number;
    };
  };
  readonly hasAccessToScheduledMeetingRecordings: boolean;
  readonly meetingGuidelines: {
    readonly attendeeWeeklyMeetingHoursLimit: number;
    readonly attendeeWeeklyMeetingHoursWarningEnabled: boolean;
    readonly breaksBetweenMeetingsBehaviour: BreaksBetweenMeetingsBehaviourEnum;
    readonly breaksBetweenMeetingsEnabled: boolean;
    readonly finiteRecurringMeetingsEnabled: boolean;
    readonly maxRecommendedAttendees: number;
    readonly meetingAttendeesEnabled: boolean;
    readonly meetingCostAvgSalary: number;
    readonly meetingCostEnabled: boolean;
    readonly meetingCostUnit: MeetingCostUnitEnum;
    readonly noMeetingDay: DayOfWeekEnum;
    readonly noMeetingDaysEnabled: boolean;
    readonly promptWhenSavingEnabled: boolean;
    readonly promptWhenSavingGuidelinesUrl: string;
    readonly shortNoticeEnabled: boolean;
    readonly shortNoticeNumHours: number;
  } | null;
  readonly remainingMeetingRecordingCredits: number;
  readonly settings: {
    readonly timezonePreferences: {
      readonly extraTimezones: ReadonlyArray<{
        readonly timezone: {
          readonly name: string;
        };
        readonly userLabel: string;
      } | null>;
      readonly preferredTimezone: {
        readonly timezone: {
          readonly name: string;
        };
        readonly userLabel: string;
      };
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"EventForm_viewer" | "WeekPreview_viewer" | "usePreferredTimezone_viewer">;
  readonly " $fragmentType": "EventFormModal_viewer";
};
export type EventFormModal_viewer$key = {
  readonly " $data"?: EventFormModal_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventFormModal_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingCostEnabled",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingCostUnit",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingCostAvgSalary",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingAttendeesEnabled",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxRecommendedAttendees",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attendeeWeeklyMeetingHoursWarningEnabled",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attendeeWeeklyMeetingHoursLimit",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noMeetingDaysEnabled",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noMeetingDay",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortNoticeEnabled",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortNoticeNumHours",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finiteRecurringMeetingsEnabled",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "breaksBetweenMeetingsEnabled",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "breaksBetweenMeetingsBehaviour",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "promptWhenSavingEnabled",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "promptWhenSavingGuidelinesUrl",
  "storageKey": null
},
v16 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TimeZone",
    "kind": "LinkedField",
    "name": "timezone",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "userLabel",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventFormModal_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAccessToScheduledMeetingRecordings",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventForm_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePreferredTimezone_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WeekPreview_viewer"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remainingMeetingRecordingCredits",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ExtensionSettings",
          "kind": "LinkedField",
          "name": "extensionSettings",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "meetingCostEnforceWorkspaceSettings",
              "storageKey": null
            },
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/),
            (v12/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/),
            (v15/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": "hasAccessToMeetingGuidelines",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "meeting_guidelines"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"meeting_guidelines\")"
            },
            {
              "alias": "hasAccessToMeetingCost",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "meeting_cost"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"meeting_cost\")"
            },
            {
              "alias": "hasAccessToMeetingRecorderFeature",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "meeting_recorder"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"meeting_recorder\")"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingGuidelines",
      "kind": "LinkedField",
      "name": "meetingGuidelines",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/),
        (v7/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserSettings",
      "kind": "LinkedField",
      "name": "settings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimezonePreferences",
          "kind": "LinkedField",
          "name": "timezonePreferences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserTimezone",
              "kind": "LinkedField",
              "name": "preferredTimezone",
              "plural": false,
              "selections": (v16/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "UserTimezone",
              "kind": "LinkedField",
              "name": "extraTimezones",
              "plural": true,
              "selections": (v16/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "deed4324190121917cc4ffc290e39cec";

export default node;
